export default __webpack_public_path__ + "static/media/exclamation.643f80ba.svg";